import { render, staticRenderFns } from "./testDrive.vue?vue&type=template&id=1a916e6a&scoped=true&"
import script from "./testDrive.vue?vue&type=script&lang=js&"
export * from "./testDrive.vue?vue&type=script&lang=js&"
import style0 from "./testDrive.vue?vue&type=style&index=0&id=1a916e6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a916e6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a916e6a')) {
      api.createRecord('1a916e6a', component.options)
    } else {
      api.reload('1a916e6a', component.options)
    }
    module.hot.accept("./testDrive.vue?vue&type=template&id=1a916e6a&scoped=true&", function () {
      api.rerender('1a916e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/social/testDrive.vue"
export default component.exports